import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MinusCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MinusCircleOutlined.displayName = 'MinusCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(MinusCircleOutlined);